<template>
  <div class="ma-6">
<!--    <div><h2>Premium Supplier</h2></div>-->
<!--    <v-divider></v-divider>-->
<!--    <v-layout row wrap class="mt-2">-->
<!--      <v-flex lg2  sm6 xs12 v-for="(item, index) in suppliergold"  :key="index">-->
<!--        <v-card class="ma-2" elevation="1">-->
<!--          <v-card-text  class="align-center align-content-center">-->
<!--            <v-img v-if="item.avatar"  width="100px" height="100px" :src="item.avatar"></v-img>-->
<!--            <v-img width="100px" height="100px" v-else src="../assets/irsicon.jpg"></v-img>-->
<!--            <div class="ma-1">{{potongnama(item.sellername)}}</div>-->
<!--            <v-row class="ml-1">-->
<!--              <v-rating :value="item.rating" color="amber" dense readonly size="14"></v-rating>-->
<!--              <div class="grey&#45;&#45;text ml-2">-->
<!--                {{item.rating}} ({{item.jmlreview}})-->
<!--              </div>-->
<!--            </v-row>-->
<!--          </v-card-text>-->
<!--          <v-divider></v-divider>-->
<!--          <v-card-actions>-->
<!--&lt;!&ndash;            <v-icon>label</v-icon> 124&ndash;&gt;-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-btn @click="gosellerpage(item.sellerid)" text>Lihat</v-btn>-->
<!--          </v-card-actions>-->
<!--        </v-card>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
    <div class="mt-10"><h2>Standar Supplier</h2></div>
    <v-divider></v-divider>
    <v-layout row wrap class="mt-2">
        <v-flex lg2  sm6 xs12 v-for="(item, index) in supplier"  :key="index">
          <v-card @click="gosellerpage(item.sellerid)" class="ma-4" elevation="1">
            <div :class="item.user.online===1?'box2':'box1'"><h5>{{tokostatustext(item.user.online)}}</h5></div>
            <v-card-title></v-card-title>
            <v-card-text class="text-center">
              <img alt="logosuplier1" class="imagesuplier" v-if="item.avatar" width="100px" height="100px" :src="item.avatar">
              <img alt="logosuplier" width="100px" height="100px" v-else src="https://res.cloudinary.com/dd5jfnv3x/image/upload/v1519482855/default-image.png"/>
              <div class="ma-1">{{potongnama(item.sellername)}}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
<!--                <v-icon>label</v-icon> 124-->
              <v-row class="ml-1">
                <v-rating :value="item.rating" color="amber" dense readonly size="14"></v-rating>
                <div class="grey--text ml-2">
                  {{item.rating}} ({{item.jmlreview}})
                </div>
              </v-row>
                <v-spacer></v-spacer>
                <v-btn icon @click="openchat(item)" text><v-icon>chat</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import S from 'string'
export default {
  name: 'Supplier',
  data: () => ({
  }),
  mounted () {
    this.getSupplierGold()
    this.getSupplier()
  },
  computed: {
    ...mapState('ProductStore', ['supplier', 'suppliergold'])
  },
  methods: {
    ...mapActions('ProductStore', ['getSupplier', 'getSupplierGold']),
    ...mapActions('ChatStore', ['setToUser', 'setdialog']),
    gosellerpage (id) {
      this.$router.push('/supplier/' + id)
    },
    openchat (seller) {
      this.setToUser({ memberid: seller.sellerid, membername: seller.sellername, avatar: seller.avatar })
      this.setdialog(true)
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Online'
      } else {
        return 'Offline'
      }
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').s
      } else {
        return val.toUpperCase()
      }
    }
  }
}
</script>

<style scoped>
.imagesuplier {
  border-radius: 10px;
  position: relative;
}
.label-buka {
  float: right;
  position: relative;
  right: 12px;
  top: 190px;
}
.box2 {
  position: absolute;
  z-index: 2;
  width: 50px;
  float: left;
  padding: 5px 20px;
  margin: 0 auto;
  background: scroll;
  border-radius: 4px;
}
.box2 h5 {
  position:relative;
  padding:0 2px;
  margin:0 -30px 1px;
  font-size:14px;
  line-height:25px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#079c07;
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  zoom:1;
}
.box2 h5:before,
.box2 h5:after {
  content:"";
  position:absolute;
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent darkgreen;
}

.box1 {
  position: absolute;
  z-index: 1;
  width: 50px;
  float: left;
  padding: 5px 20px;
  margin: 0 auto;
  background: scroll;
  border-radius: 4px;
}
.box1 h5 {
  position:relative;
  padding:0 2px;
  margin:0 -30px 1px;
  font-size:14px;
  line-height:25px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#cccccc;
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  zoom:1;
}

.box1 h5:before,
.box1 h5:after {
  content:"";
  position:absolute;
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent #cccccc;
}

</style>
